import { createElement, useEffect, useRef } from 'react';

type SidebarResizeHandleProps = {
  onResize: (width: number) => void;
  getWidth: () => number;
};

export function SidebarResizeHandle({ onResize, getWidth }: SidebarResizeHandleProps) {
  const draggingRef = useRef(false);

  useEffect(() => {
    function onPointerMove(event: PointerEvent): void {
      if (!draggingRef.current) {
        return;
      }
      onResize(getWidth() + event.movementX);
    }

    function onPointerUp(): void {
      draggingRef.current = false;
    }

    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
    return () => {
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
    };
  }, [getWidth, onResize]);

  return createElement('div', {
    className: 'absolute bottom-0 right-0 top-0 z-10 hover:bg-accent/20',
    style: { width: 4, cursor: 'col-resize', touchAction: 'none' },
    onPointerDown: (event: PointerEvent) => {
      event.preventDefault();
      draggingRef.current = true;
    },
  });
}
